import HeroContext, { useHeroIntersection } from 'remote-com-shared/components/Hero/context';

import { Banner } from '@/src/components/Banner/Banner';
import { hasBanner } from '@/src/components/Banner/helpers';
import WebinarFooter from '@/src/components/Footer/WebinarFooter';
import { transformProperties } from '@/src/domains/prismic/helpers';

export const WebinarLayout = ({ sharedServices, children }) => {
  const heroIntersection = useHeroIntersection();
  const { bannerSitewide } = sharedServices ?? {};
  const bannerProps = transformProperties(bannerSitewide);
  const { description } = bannerProps ?? {};

  return (
    <HeroContext.Provider value={heroIntersection}>
      {hasBanner(description) ? <Banner {...bannerProps} /> : null}
      {children}
      <WebinarFooter />
    </HeroContext.Provider>
  );
};
